<template>
  <v-dialog
    v-model="dialog"
    max-width="620"
    persistent
    style="background:#fff;"
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-file-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Bifogade filer</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-card-title class="color-a" style="background:#fff;margin-bottom: -3px;">
      Bifogade filer
    </v-card-title>

    <v-card>
      <v-card-text>
        <v-list>
          <v-list-item v-for="file in files" :key="file.fullPath">
            <v-list-item-icon>
              <v-icon>mdi-pdf-box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <a :href="file.url" target="_blank">
                <v-list-item-title>{{ file.name }}</v-list-item-title>
              </a>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon @click="deleteFile(file)">mdi-delete</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-row class="mx-auto" style="margin-top: 50px">
          <v-col md="9">
            <v-file-input
              dense
              accept=".pdf"
              v-model="file"
              label="Fil"
            ></v-file-input>
          </v-col>
          <v-col md="3">
            <v-btn @click="uploadFile">Ladda upp</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Stäng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    meeting: Object
  },
  components: {},
  data() {
    return {
      dialog: false,
      file: null
    };
  },
  computed: {
    files() {
      return this.$store.getters["meetings/getMeetingFiles"];
    }
  },
  watch: {
    dialog: function(value) {
      if (value) {
        this.$store.dispatch("meetings/loadFiles", this.meeting);
      } else {
        this.$store.dispatch("meetings/clearFiles", this.meeting);
      }
    }
  },
  methods: {
    async deleteFile(fileRef) {
      this.$store.dispatch("meetings/deleteFile", {
        meeting: this.meeting,
        fileRef: fileRef
      });
    },
    async uploadFile() {
      if (this.file) {
        this.$store.dispatch("meetings/uploadFile", {
          meeting: this.meeting,
          file: this.file
        });
        this.file = null;
      }
    },
    close() {
      /* this.$refs.form.close(); */
      this.dialog = false;
    }
  }
};
</script>

<style></style>
